/**
 * HTTP client (infrastructure layer).
 *
 * Cookie-based auth: the browser ships the HTTP-only access_token cookie
 * automatically because the SPA is served same-origin via the SWA proxy
 * (see staticwebapp.config.json once deployed; in dev, vite.config.ts
 * proxies /api). On 401 we clear the in-memory user and dispatch a custom
 * event so the route shell can transition to /login without prop drilling.
 */
import axios, { type AxiosInstance } from 'axios';

export const ADMIN_API_BASE = '/api/v1/admin';
export const AUTH_API_BASE = '/api/v1/auth';

export const UNAUTHENTICATED_EVENT = 'admin:unauthenticated';

export function createApi(baseURL = ''): AxiosInstance {
  const api = axios.create({
    baseURL,
    withCredentials: true,
    timeout: 15_000,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
  });

  api.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 401) {
        window.dispatchEvent(new CustomEvent(UNAUTHENTICATED_EVENT));
      }
      return Promise.reject(err);
    },
  );

  return api;
}

export const apiClient = createApi();
